import themes from 'devextreme/ui/themes';
import config from 'devextreme/core/config';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

config({
  licenseKey:
    "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImY3NTJjZmMxLWIyYWItNDAwNy04MTc1LWMwMDI1MDMzYzM3YSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.q7DD8pGcqcJT9mUn7pltP9f9k9nLLG+TCRojXsDhAPghVaHeY7bHKcn1OWvcwBG3MzO7bcZuGLEeKzYbbo1aIIqZnNBYdm8sdhRSHbxP8CuzaYvfuUmfjcMeZFYZ1KIgGFpzLQ==",
});

themes.initialized(() => {
  bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
});


